export enum AudioFileType {
    Mp3 = 'MP3',
    Wav = 'WAV',
    Trackout = 'Trackout'
}
